export default __webpack_public_path__ + "static/media/sku.4d4deedb.svg";